import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-slate-300 font-sans overflow-x-hidden selection:bg-brand-cyan/30 selection:text-cyan-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <WhatYouGet data-id="element-4" />
      <AudienceSection data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <SocialProof data-id="element-7" />
      <FAQSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}